/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Popup from 'reactjs-popup';
import { CSSTransition } from 'react-transition-group';

import NearForm from './nearForm';
import { switchNearTicketsPopupAction } from './actions';
import { ReactComponent as IconClose } from '../../assets/close-popup.svg';

import './style.scss';

class NearTickets extends React.Component {
    constructor() {
        super();

        this.ref = React.createRef();
    }

    onSwitchPopup = () => {
        const { dispatch } = this.props;
        dispatch(switchNearTicketsPopupAction());
    }

    render() {
        const { nearTickets } = this.props;


        return (
            <div className="schedule__near-tickets">
                <div className="tooltip" ref={this.ref}>Подобрать ближайший талон</div>
                <button
                    type="button"
                    onClick={() => this.onSwitchPopup()}
                    className="btn"
                    onMouseOver={() => {
                        this.ref.current.classList.add('show');
                    }}
                    onMouseLeave={() => {
                        this.ref.current.classList.remove('show');
                    }}
                >
                    Ближайший талон
                </button>
                <CSSTransition
                    classNames="schedulePopup"
                    in={nearTickets.visibleNearPopup}
                    unmountOnExit
                    timeout={{
                        appear: 0,
                        enter: 0,
                        exit: 300,
                    }}
                >
                    <Popup
                        position="center center"
                        open
                        className="schedule__popup"
                        closeOnEscape={false}
                        closeOnDocumentClick={false}
                    >
                        <>
                            <p className="schedule__popup_title"><b>Подбор ближайшего талона</b></p>
                            <button type="button" className="schedule__popup_close" onClick={() => this.onSwitchPopup()}>
                                <IconClose />
                            </button>
                            <NearForm />
                        </>
                    </Popup>
                </CSSTransition>
            </div>
        );
    }
}

NearTickets.propTypes = {
    dispatch: PropTypes.func.isRequired,
    nearTickets: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    nearTickets: state.nearTickets
});


export default connect(mapStateToProps)(NearTickets);
